import React, { useState, useEffect, useRef } from "react";

import "./ChooseFileDialog.css"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { getSupportedImageTypes, isImageTypeSupported } from "../../helpers/img-helpers/ImageSupportHelper";

export enum FileType{
    Image = 0,
    File = 1,
    Archive = 2
}

interface chooseFileDialogProps {
    label?: string;
    isDisabled?: boolean;
    onFileChoosen(file: File, type: FileType): void;
}

export default function ChooseFileDialog(props: chooseFileDialogProps) {
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null);
    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
    const selectedFileType = useRef<FileType>(FileType.File);

    const _onFileSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        // Task #380 - fix for IOS files uploading: reset the input so the same file can be chosen again
        e.target.value = "";
        if(!file) return;
        props.onFileChoosen(file, selectedFileType.current);
    }

    const buildFileSelector = (accept: string) => {
        const fileSelector = inputRef.current;
        if(!fileSelector) return;
        fileSelector.setAttribute('accept', accept);
        return fileSelector;
    }

    const _onMenuChoosenHandler = (type: FileType): void => {
        selectedFileType.current = type;
        let accept = "";
        
        switch(type){
            case FileType.Image: {
                accept = getSupportedImageTypes();
                break;
            }
            case FileType.Archive: {
                accept = ".zip";
                break;
            }
        }
        buildFileSelector(accept)?.click();
        setIsMenuVisible(false);
    }
    
    return (
        <React.Fragment >
            <input ref={inputRef} type="file" className='input-file__hidden' onChange={_onFileSelected}/>
            <Dropdown className="choose-file-dialog__container" isOpen={isMenuVisible} toggle={() => {setIsMenuVisible(!isMenuVisible)}} disabled={props.isDisabled}>
                <DropdownToggle tag="div" onClick={props.label != null ? () => _onMenuChoosenHandler(FileType.Archive) : undefined}>
                    <i className={(props.label == null ? "material-icons choose-file-dialog__attach-image" : "choose-file-dialog__label") + (props.isDisabled ? " disabled" : "")}>attach_file</i>
                    {props.label == null && <img /> || <div>{props.label}</div>}
                    {(isMenuVisible && props.label == null) &&
                    <DropdownMenu style={{}} className="choose-file-dialog__menu">
                            <div data-testid="choose-file-image" onClick={() => { _onMenuChoosenHandler(FileType.Image) }} className="choose-file-dialog__menu-item">{t('common.image')}</div>
                            <div data-testid="choose-file-file" onClick={() => { _onMenuChoosenHandler(FileType.File) }} className="choose-file-dialog__menu-item">{t('common.file')}</div>
                    </DropdownMenu>}
                </DropdownToggle>                
            </Dropdown>
        </React.Fragment>
    )
}